module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-pulse-badge-973920d2ae1c2997eb6fafcb3c97c5d3.svg";